import type { Option } from './types'

export function filterOptionsByLabel(
  options: Option[] | undefined,
  query: string
): Option[] | undefined {
  const normalizedQuery = query.trim().toLocaleLowerCase()
  if (!normalizedQuery) return options
  return options?.filter((option) =>
    option.label.toLocaleLowerCase().includes(normalizedQuery)
  )
}
